// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/galleryslider.less
// module id = 409
// module chunks = 0